module.exports = __webpack_public_path__ + "media/images/lp/1/tamai-sp-9a230f708f18313bdf1d847d881eb76f.jpg";